import { useState } from 'react';

import type { FileRecord } from '../domain-types';

export function useFiles() {
  const [files, setFiles] = useState<FileRecord[]>([]);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [uploadingFile, setUploadingFile] = useState(false);
  return { files, setFiles, selectedFile, setSelectedFile, uploadingFile, setUploadingFile };
}
